const getAdultsLocalizationKey = (value) =>
    `th.inbox.conversation.tripSummary.guests.${
        value === '1' ? 'single.adult' : 'multi.adults'
    }`;

const getChildrenLocalizationKey = (value) =>
    `th.inbox.conversation.tripSummary.guests.${
        value === '1' ? 'single.child' : 'multi.children'
    }`;

module.exports = {
    getAdultsLocalizationKey,
    getChildrenLocalizationKey,
};
